import { createFeatureSelector, createSelector } from '@ngrx/store';
import {
  STATE_FEATURE_KEY,
  StateState,
  StatePartialState,
  stateAdapter
} from './state.reducer';

// Lookup the 'State' feature state managed by NgRx
export const getStateState = createFeatureSelector<
  StatePartialState,
  StateState
>(STATE_FEATURE_KEY);

const { selectAll, selectEntities } = stateAdapter.getSelectors();

export const getStateLoaded = createSelector(
  getStateState,
  (state: StateState) => state.loaded
);

export const getStateError = createSelector(
  getStateState,
  (state: StateState) =>  state.error
);

export const loadingState = createSelector(
  getStateState,
  (state: StateState) =>  state.loaded
);

export const getAllState = createSelector(
  getStateState,
  (state: StateState) => selectAll(state)
);

export const getStateEntities = createSelector(
  getStateState,
  (state: StateState) => selectEntities(state)
);

export const getSelectedId = createSelector(
  getStateState,
  (state: StateState) => state.selectedStateId
);

export const getSelected = createSelector(
  getStateEntities,
  getSelectedId,
  (entities, selectedId) => selectedId && entities[selectedId]
);
